import script from "./AgentAssistant.vue?vue&type=script&setup=true&lang=js"
export * from "./AgentAssistant.vue?vue&type=script&setup=true&lang=js"

import "./AgentAssistant.vue?vue&type=style&index=0&id=791108ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-791108ce"]])

export default __exports__